const PageTitle = () => {
  return null;
};

export default PageTitle;
